// src/assets/translations/hebrew.json

export const messagesFixture = {
  INVALID_DATE: "הוזן תאריך לא נכון",
  general_error: "שגיאה  ",
  personal_details: "פרטים אישיים",
  adding_new_discount: "הזנת סבסוד חדש",
  display_budget_sections_of_nests_not_in_event:
    "הצגת סעיפי תקציב של קנים שאינם באירוע",
  discount_select_event: "בחירת אירוע",
  change_amount: "שינוי סכום",
  discount_select_parent_event: "בחירת אירוע אב",
  discount_select_child: "בחירת חניכ/ים",
  placeholder_discount_select_child: "הקלידו שם חניכה או ת.ז",
  placeholder_discount_select_event: "הקלידו שם ארוע או קוד ארוע",
  discount_set_discount: "הגדרת סבסוד",
  pricings: "תמחורים",
  editing_existing_discount: "עריכת סבסוד קיים",
  system_privileges: "הרשאות מערכת",
  privilege_type: "סוג הרשאה",
  activity_field: "שדה פעילות",
  password_management: "ניהול סיסמא",
  additional_info: "מידע נוסף",
  passwords_dont_match: "הסיסמאות אינן תואמות",
  must_use_a_strong_password:
    "  הסיסמה חייבת לכלול לפחות ספרה אחת, אות קטנה אחת, אות גדולה אחת, ולהיות באורך של לפחות 8 תווים",

  no_login: "שגיאה בשם משתמש/ת או סיסמה",
  no_login_brute_force: "שגיאה! משתמש/ת חסומ/ה עקב ריבוי ניסיונות",
  no_data: "אין נתונים",
  no_personal_id: "נדרשת ת.ז.",
  no_table_data: "אין נתונים,פנה לאדמין",
  confirm: "אישור",
  cancel: "ביטול",
  must: " חייב",
  no_payments_found: "לא נמצאו תשלומים",
  select: " בחר",
  COMMENT: "הערה",
  phone_not_valid: "טלפון לא תקין",
  field_is_required: "שדה חובה",
  number_not_valid: "מספר לא תקין",
  email_not_valid: "מייל לא תקין",
  length_not_valid: "אורך שדה לא תקין",
  password_not_valid: "סיסמה לא תקינה",
  active_user: "משתמש.ת פעיל.ה",
  deleted_user: "משתמש.ת מחוק.ה",
  super_user: "משתמש.ת על",
  rakaz_user: "רכז.ת",
  limited_privileges: "הרשאות מוגבלות",
  view_only: "צפייה בלבד",
  cash_collection: "גבייה במזומן",
  credit_collection: "גבייה באשראי",
  refund_management_password: "סיסמת ניהול החזרים",
  must_choose_at_least_one_option: "יש לבחור לפחות אפשרות אחת",
  password_desc:
    "סיסמה לא תקינה. על הסיסמא להיות מורכבת מלפחות 8 תווים, ספרה, אות אנגלית גדולה ואות אנגלית קטנה.",
  personalId_not_valid: "ת.ז. לא תקינה",
  email_field: "מייל",
  correct_mail: "מייל תקני",
  password_field: "סיסמה",
  city_field: "ישוב",
  address_field: "כתובת",
  password_explain_placeholder:
    "סיסמה, לפחות 8 תווים באנגלית, הכוללים לפחות כל אחד מהבאים: מספר ואות גדולה/קטנה",
  firstNameChild_field: "שם פרטי - ילד/ה",
  lastNameChild_field: "שם משפחה - ילד/ה",
  gender_field: "מין ילד/ה",
  personalId_field: "תעודת זהות",
  nest_field: "קן / סניף / מוקד פעילות",
  birthday_field: "תאריך לידה",
  parentFirstName_field: "שם פרטי - הורה",
  parentLastName_field: "שם משפחה - הורה",
  parentPersonalId_field: "תעודת זהות - הורה",
  parentCheckountFirstName_field: "שם פרטי של הורה",
  parentCheckoutLastName_field: "שם משפחה של הורה",
  parentCheckoutEmail_field: "מייל לשליחת קבלה",
  parent_email_field: "דואר אלקטרוני של הורה",
  price_without_cost: "ללא עלות",
  parentCheckoutPhone_field: "טלפון הורה",
  bankAccount_field: "מספר חשבון",
  cancelReason_field: "סיבת בקשה",
  bankBranch_field: "סניף",
  bankName_field: "בנק",
  phone_field: "טלפון נייד",
  phone_2_field: "טלפון נוסף",
  originChild_field: "ארץ לידה של הילד/ה",
  originParent_field: "ארץ לידה של ההורה",
  firstName_field: "שם הורה",
  firstName_user_field: "שם פרטי",
  lastName_field: "שם משפחה ",
  newsletter_field: "דואר אלקטרוני",
  cellular_field: "סלולרי",
  street_field: "רחוב",
  houseNum_field: "בית",
  appartNum_field: "דירה",
  CityZipCode_field: "מיקוד",
  refundCode_field: "קוד החזר",
  superAdmin_field: "סופר אדמין",
  isTalpan_field: "טלפן",
  birthDate_field: "תאריך לידה",
  active_field: "פעיל",
  onlyMobile_field: "צופה בלבד",
  garinInstructor_field: "רכז גרעין",
  dualCircleAdmin_field: "מנהל 2 מעגלים",
  deleted_field: "מחוק",

  viewer_field: "צופה",
  isMeshutaf_field: "משותף",
  userName_field: "שם משתמש",
  userName_field_more_details: "שם משתמש (אותיות קטנות באנגלית ומקף בלבד)",
  jobRole_field: "תפקיד",
  branch_field: "סניף",
  county_field: "מחוז",
  circle_field: "מעגל",
  payment: "תשלום",
  event: "אירוע",
  amount: "סכום",
  quantity: "כמות",
  child: "חניך",
  status: "סטטוס",
  action: "ביצוע פעולות",
  noChecksForContribution: "שימו לב! לא ניתן לשלם לתרומה באמצעות צ'קים",
  actions: "פעולות",
  authNumber: "קוד אישור",
  refund_reason: "סיבת בקשת ההחזר",
  cancel_reason: "סיבת דחייה/אישור",
  cash_payment: "תשלום מזומן",
  label_cash: "מזומן",
  label_payment_4: "מזומן",
  label_cheque: "שיק",
  label_payment_5: "שיק",
  label_cheque_number: "מספר שיק",
  label_date: "תאריך",
  add_to_cart: "הוספה לסל",
  label_available_events: "אירועים זמינים",
  save: "שמירה",
  save2: "שמור",
  dismiss: "לא",
  approve: "כן",
  confirm_refund: "האם את/ה בטוח/ה?",
  refund: "החזר",
  refund_request: "בקשת החזר",
  refund_request_cash: "לביטול הקבלה",
  admin_mihlol_save:
    "רכז/ת שימו לב, השמירה תשפיע על המכלול עבור כלל החניכות והחניכים",
  menu_mihlol: "מכלול אירועים",
  menu_payments: "תשלומים",
  menu_content: "ניהול תוכן",
  menu_refunds_by_circle: "החזרים לפי מעגל",
  menu_open_receipts: "קבלות פתוחות",
  menu_payment: "לתשלום",
  menu_collective: "קבלה קיבוצית",
  menu_brothers: "הנחת אחים",
  brother_request_modal_header: "שיוך אחים",
  brother_request_modal:
    "תוכן ההודעה: החניכ.ה $1$ נוצר.ה בהצלחה. האם ברצונך להגיש בקשה לשיוך אחים?",
  brother_request_modal_was_created_successfully:
    "ברוך הבא לחניכ.ה $1$ שמחים על ההצטרפותכם",
  brother_request_modal_was_updated_successfully: "החניכ.ה $1$ עודכנ.ה בהצלחה.",
  brother_request_modal_chanich_attributed:
    "החניכ.ה $1$ נוצר.ה בהצלחה, ושוייכ.ה לאחים:",
  brother_request_modal_chanich_not_attributed_ver2: " שמנו לב ש$1$ ו",
  brother_request_modal_do_not_attribute_button_ver2: " לא לשייך",
  brother_request_modal_chanich_not_attributed: "האחים הללו לא שוייכו ל$1$: ",
  brother_request_modal_would_you_like_to_make_request:
    " האם ברצונך להגיש בקשה לשיוך אחים?",
  brother_request_modal_would_you_like_to_make_request_ver2:
    "לא משוייכים כאחים. אם הם אחים - מזמינים אותך לשייך",
  to_brother_discount: "מעבר לשיוך אחים",
  passed_discount_committee: "עבר ועדת סבסודים",
  menu_admin: "ניהול מערכות",
  checkout_header: "חשבון",
  checkout_policy: "נהלי תשלום",
  checkout_content: "פירוט",
  checkout_total: "סך הכל:",
  checkout_confirmation1:
    "אני מאשר/ת כי כל הפרטים שמסרתי נכונים, שקראתי ואישרתי את הסכם ההבנות בין התנועה להורים ומאשר/ת את השתתפותו/ה של בני/ ביתי בפעילות עליה שילמתי.",
  checkout_confirmation2:
    "אני מאשר/ת שקראתי והסכמתי לנוהל ההחזרים כפי שמפורסם באתר התנועה",
  checkout_numberOfPayments: "מספר תשלומים",
  checkout_checkout: "בחר/י אופן תשלום",
  checkout_checkout_message: "תשלום מאובטח באשראי",
  checkout_checkout_meshutaf: 'תשלום משותף ע"י הישוב',
  checkout_checkout_cash: "תשלום במזומן ו/או שיק",
  checkout_checkout_meshutaf_popup:
    'הבקשה להרשמה הועברה למורשה חתימה בישוב לאישור ההרשמה הסופי, הרשמתך תיקלט רק לאחר אישור הישוב ולא יאוחר מתאריך סגירה ההרשמה לאירוע.<br/>לאחר האישור ישלח דוא"ל לכתובתך (שם המשתמש/ת איתו נכנסת למערכת). כמו כן למעקב וביצוע החזרים, תופיע הבקשה להרשמה וההרשמה בהסיטוריית התשלומים באתר',
  refund_meshutaf_popup_header: "בקשת ההחזר נקלטה בהצלחה",
  finish_registration: "סיום הרשמה",
  refund_meshutaf_popup_body:
    "בקשת ההחזר תטופל בהתאם לנוהל ההחזרים של הנוער העובד והלומד.<br/>במידה ויאושר החזר,יש להסדיר את אופן קבלת ההחזר מול גורם הרלוונטי בישוב.",
  checkout_confirmation: "נדרש אישור",
  checkout_discount: "הנחה",
  checkout_no_items: "לא נמצאו פריטים",
  checkout_about: "אודות ",
  save_child_success: "הילד/ה נשמר בהצלחה!",
  save_changes: "שמירת שינויים",
  save_success: "נתונים נשמרו בהצלחה!",
  new_brother_requests: "בקשות שיוך חדשות",
  child_already_exists: "הילד/ה כבר קיים/ת במערכת!",
  child_already_exists_and_doesnt_belongs_to_you:
    "לא ניתן לבצע שיוך החניכ/ה להורה - קיים חניכ/ה זהה במערכת יש לפנות לרכז/ת הקן להמשך השיוך",
  michlol_nothing_to_save: "אין ארועים לשמירה במכלול",
  not_authorized: "המשתמש/ת לא מורשה לביצוע פעולה זו",
  history_no_children: "לא ניתן להציג היסטורית תשלומים מבלי לבחור ילדים",
  reset_password: "איפוס סיסמה",
  reset_password_limit: "יותר מדי ניסיונות,האופציה חסומה ל 24 שעות",
  admin_send_to_mail: "שליחה למייל",
  admin_send_to_phone: "שליחה ב SMS",
  admin_send_to_phone_failed: "שליחה לנייד נכשלה,פנה לאדמין",
  admin_send_to_success: "ההודעה עם הקישור נשלחה בהצלחה ל",

  admin_reset_password_send_to_success: "הודעה נשלחה למייל של",
  admin_copy_console: "העתקה",
  admin_copy_success: "העתקה הושלמה בהצלחה. ניתן להשתמש בתוצאה בעזרת CTRL+V",
  admin_users_mehutaf: "הוספת מאשרי תשלום במשותף",
  admin_users_invoice_address: "מען למשלוח חשבונית",
  admin_users_het_pay: "ח.פ. ישוב",
  admin_users_invoice_name: "שם הגוף המשלם",
  admin_users_viewer: "צופה",
  admin_users_mobile: "תשלומון",
  admin_users_meshutaf: "מאשר תשלום במשותף",
  status_meshutaf_NEW: "ממתין",
  REFUND_REQUESTED: "בקשת החזר",
  status_meshutaf_APPROVED: "הופקה התחייבות",
  hebrew_by: "על ידי",

  status_meshutaf_CANCELED: 'בוטל ע"י הורה',
  status_meshutaf_REFUND_REQUESTED: "זיכוי בטיפול",
  status_meshutaf_REFUND_APPROVED: "אושר זיכוי",
  refund_request_meshutaf_NEW: "בהתאם לנוהל ההחזרים, הרשמה זו תבוטל בטרם החיוב",
  admin_meshutaf_approve_popup:
    'הננו מתחייבים לשלם לעמותת הנוער העובד והלומד, בשיק/העברה בנקאית עם קבלת החשבונית,עבור הפעילות "$1$",סך של $2$ ש"ח עבור $3$ חניכים.<br/>התשלום יתבצע תוך 70 יום מקבלת החשבונית.',
  admin_meshutaf_approve_popup_success: "ההתחייבות הופקה בהצלחה",
  numberOfChildren: "מספר חניכים",
  admin_add_child: "חיפוש חניך",
  admin_search: "חיפוש",
  filter_results: "סינון תוצאות",
  only_checks: "שיקים בלבד",
  partial_deposits_only: "הפקדות חלקיות בלבד",

  admin_user: "מסך הורה",
  admin_parent: "הורה",
  admin_edit: "עריכת פרטים",
  edit_activity_fields: "עריכת שדות פעילות",
  edit: "עריכה",
  remove: "הסרה",

  feature_not_implemented_header: "לא פעיל",
  feature_not_implemented_text: "אפשרות זו תתווסף בהמשך",
  attribute_brothers_and_sisters: "שיוך אחים ואחיות",
  discount_exist_for_chanich:
    "קיים סבסוד לתמחור זה עבור החניכ/ה - ניתן לערוך את הסבסוד במסך העריכה",
  export_to_excel: "יצוא לאקסל",
  make_active: "הפוך לפעיל",
  make_inactive: "הפוך ללא פעיל",
  password_reset: "  איפוס סיסמה",
  you_have_selected: " נבחרו",
  users: "  משתמשים",

  import_users_excel: "יבוא אקסל משתמשים",
  to_download_an_example_file: "להורדת קובץ לדוגמא לחצו",
  upload_file: "העלאת קובץ",
  send_file: "שליחת קובץ",
  to_download_an_example_file_here: "כאן",
  import_users_excel_instruction_complex:
    "יש להוריד את הקובץ המצורף, ולמלא אותו בהתאם להוראות. יש לשים לב שכל שדות החובה מלאים. ",
  import_users_excel_instructions_one:
    "העלאת קובץ אקסל / csv עבור יצירת כמות משתמשים במערכת",

  attribute_brothers: "שיוך אחים ואחיות",

  admin_select_child: "בחירה בחניכ/ה",
  admin_select_parent: "בחירה בהורה",
  admin_add_child_meshutaf: "הוספת ילד/ה לרשימה",
  admin_create_child: "הוספת ילד/ה",
  admin_create_child_meshutaf: "יצירת ילד/ה חדש/ה במערכת",
  number1: "ראשון",
  number2: "שני",
  number3: "שלישי",
  number4: "רביעי",
  number5: "חמישי",
  number6: "שישי",
  number7: "שביעי",
  number8: "שמיני",
  number9: "תשיעי",
  number10: "עשירי",
  collective_create_receipt: "הפקת קבלה קיבוצית",
  collective_for: "קבלה קיבוצית עבור",
  collective_number_of_children: "כמות חניכות וחניכים",
  collective_amount: "סכום שנגבה",
  collective_for_child: "לחניכ/ה",
  open_receipts_label: "קבלות פתוחות",
  open_receipts_filter: "סינון קבלות",
  open_receipts_my: "קבלות שלי",
  open_receipts_others: "קבלות של אחרים",
  open_receipts_produced_by: "הופק על ידי ",
  open_receipts_deposit: "הפקדה",
  open_receipts_deposit_all: "להפקיד הכל יחד",
  open_receipts_close: "סגירת קבלה",
  open_receipts_close_word: "סגירת",
  open_receipts_receipt_word: "קבלות",
  open_receipt: "קבלה פתוחה",
  event_open_to: "למי פתוח הארוע",
  open_receipts_deposit_number: "מספר אסמכתת הפקדה",
  check_number: "מספר צ'ק",
  due_date: "תאריך פרעון",
  check_amount: "סכום צ'ק",
  open_receipts_deposit_date: "תאריך אסמכתת הפקדה",
  open_receipts_deposit_amount: "סכום הפקדה",
  open_receipts_deposit_close: "סגירת הקבלה עם ההפקדה",
  amount_doesnt_cover_receipt: "סכום ההפקדה אינו מכסה את סכום הקבלה",
  direct_to_open_receiptd: "קח אותי לסגירת קבלות",
  direct_to_open_receiptd_body:
    "נראה שתשלום זה עדיין פתוח. על מנת לסגור אותו עבור למסך הקבלות הפתוחות",
  open_receipts_deposit_success: "הקבלה נסגרה בהצלחה עם הפקדה מספר $1$",
  open_receipts_deposit_success_partly: "הקבלה נסגרה חלקית עם הפקדה מספר $1$",
  open_receipts_deposit_date_cannot_be_a_future_date:
    "תאריך ההפקדה לא יכול להיות בעתיד",
  open_receipts_deposit_date_cannot_be_a_far_past_date:
    "אין אפשרות להזין הפקדה ישנה שאינה מהשנתיים האחרונות",
  open_receipts_deposit_amount_error: "סכום ההפקדה גדול מדי",
  open_receipts_deposit_amount_cheque_error: "סכום ההפקדה לא תואם",
  open_receipts_deposit_not_allowed: "אין הרשאות בשביל לסגור הפקדות חלקיות",
  cheques_only: "שיקים בלבד",
  not_completely_deposited: "הפקדות חלקיות",
  meshutaf_no_events: "האירוע אינו פתוח לשכבת הגיל של החניכ/ה",
  meshutaf_event_registered: "החניכ/ה כבר רשומ/ה לאירוע",
  meshutaf_event_waiting:
    "החניכ/ה כבר רשומ/ה למפעל יש לאשר את ההרשמה ולהפיק התחייבות",
  rikuz_numbers: "מספרי ריכוז",
  admin_event_types: "ניהול סוגי ארועים",
  admin_events_management: "ניהול  ארועים",
  admin_brothers_and_sisters: "אחים ואחיות",
  admin_brothers_and_sisters_add_brothers: "אחים ואחיות",
  admin_manage_brothers_and_sisters: "ניהול אחים ואחיות",
  admin_user_management: "ניהול משתמשים",
  admin_add_user: "הוספת משתמש",
  import_from_file: "יבוא קובץ",
  price: "מחיר",
  pricing: "תמחור",
  all_pricing: "כל התמחורים",
  discount: "סבסוד",
  paid_for: "רשום",
  for: "עבור",
  with_amount: "על סך",
  subsidies: "סבסודים",
  add_subsidy: "הזנת סבסוד",
  edit_attribute_brothers_and_sisters: "עריכת שיוך אחים ואחיות",
  add_or_remove_child_from_family: "הסרה או הוספה של ילד/ה לשיוך משפחתי",
  add_children_to_family: "הוספה של ילד/ה לשיוך משפחתי",
  from_date: "מתאריך",
  to_date: "עד תאריך",
  edit_child_note: "אישור והוספת פרטים חסרים",
  payment_status_VALID_PAYMENT: "תשלום תקין",
  payment_status_OPEN_DEPOSIT: "קבלות פתוחות",
  payment_status_REFUND_APPROVED: "אושר החזר מלא/בוטלה ההרשמה",
  payment_status_REFUND_APPROVED_PARTIAL: "אושר החזר חלקי",
  payment_status_NEW_REFUND_REQUEST: "בקשת החזר חדשה",
  payment_status_REFUND_RENEW_COMMENT: "בקשת החזר עם הערת רכז",
  payment_status_REFUND_APPROVED_FIRST: "בקשת החזר - אושר ראשון",
  payment_status_REFUND_DENIED_FIRST: "בקשת החזר - נדחה ראשון",
  payment_status_REFUND_DENIED: "בקשת החזר שנדחתה",
  payment_type_CASH: "מזומן",
  payment_type_CREDIT_CARD: "אשראי",
  payment_type_CHECK: "צ'ק",
  payment_type_CASH_AND_CHECK: "מזומן וצ'ק",
  payment_type_COMMITMENT: "משותף",
  payment_date_option_PAYMENT: "תשלום",
  payment_date_option_LAST_CHANGE: "שינוי אחרון",
  payment_date_option_RETURN_REQUEST: "בקשת החזר",
  payment_return_type_CREDIT: "אשראי",
  payment_return_type_TRANSFER: "העברה בנקאית",
  payment_return_type_COMMITMENT: "זיכוי התחייבות",
  payment_deposit_option_DEPOSIT: "הפקדה",
  payment_deposit_option_DEPOSIT_CLOSED: "סגירת הפקדה",
  payment_return_action_type_APPROVE: "אישור",
  payment_return_action_type_DENY: "דחייה",
  payment_return_action_type_COMMENT: "הערה",
  payment_return_action_type_RENEW: "החזרה",
  REFUND_APPROVED: "בקשה מאושרת",
  REFUND_DENIED: "בקשה נדחתה",
  REFUND_RENEWED: "בקשה שחזרה",
  payment_return_admin_message:
    'האם את/ה בטוח/ה שברצונך להחזיר $1$ ₪ ל$2$ חניכות וחניכים,\n סה"כ $3$ ₪?',
  payment_return_admin_amount_message:
    'האם את/ה בטוח/ה שברצונך להחזיר $1$ ₪ ל$2$ חניכות וחניכים,\n סה"כ $3$ ₪?',
  payment_return_admin_percent_message:
    'האם את/ה בטוח/ה שברצונך להחזיר $1$% ל$2$ חניכות וחניכים,\n סה"כ $3$ ₪?',
  payment_collective_return_numders_of_children: "בחרת $1$ הרשמות",
  payment_collective_return_one_child: "בחרת הרשמה אחת",
  comments: "הערות",
  no_comments: " ללא הערות",
  unknown_discount_approval: "מאשר לא ידוע",
  collective_COMMENT_succeed: "הערות נוצרו בהצלחה:",
  collective_APPROVE_succeed: "החזר בוצע בהצלחה:",
  collective_DENY_succeed: "דחיית החזרים בוצעה בהצלחה:",
  collective_RENEW_succeed: "החזרת בקשות החזר בוצעה בהצלחה:",
  collective_COMMENT_failed: "שגיאות ביצירת הערה:",
  collective_APPROVE_failed: "שגיאות בביצוע החזר:",
  collective_DENY_failed: "שגיאות בדחיית ההחזר:",
  collective_RENEW_failed: "שגיאות בהחזרת בקשות החזר:",
  childOrParentName_field: "חניך/ הורה",
  nestOrBranch_field: "שם קן/ סניף",
  nest: "קן",
  layer_field: "שכבה",
  choosePayemntStatus_field: "בחר סטטוס תשלום",
  paymentDate_field: "תאריך תשלום",
  regestration_end_date: "תאריך סגירת ההרשמה",
  fromDate: "מתאריך",
  last_login: "כניסה אחרונה",
  toDate: "עד תאריך",
  sum_field: "סכום",
  fromSum: "מסכום",
  toSum: "עד סכום",
  paymentType_field: "סוג תשלום",
  returnType_field: "סוג ההחזר",
  allYears: "כל השנים",
  receiptNumberOrCommitment_field: "מספר קבלה/ התחייבות",
  receiptIssuer_field: "מנפיק הקבלה",
  countryOfChild_field: "ארץ לידה של החניכ/ה",
  countryOfParent_field: "ארץ לידה של ההורה",
  closingDate_field: "תאריך סגירת ההפקדה",
  paymentItemsId_field: "מזהה ייחודי",
  new_shekel: 'ש"ח',
  new_shekel_symbol: "₪",
  current_discount: "סבסוד נוכחי",
  updated_discount: "סבסוד חדש (מוצג בשקלים)",
  new_price_after_discount: "מחיר חדש לאחר סבסוד",
  chanich_name: "שם חניך",
  pricing_code: "קוד תמחור",
  discount_height: "גובה הסבסוד",
  final_price: "מחיר סופי",
  current_price: "מחיר נוכחי",
  price_before_discount: "מחיר לפני סבסוד",
  price_after_discount: "מחיר לאחר סבסוד",
  discount_in_shekels: "סבסוד בשקלים",
  discount_in_percent: "סבסוד באחוזים",
  payments_child: "ילד",
  payments_parent: "הורה",
  parents: "הורים",
  children: "ילדים",
  email: 'דוא"ל',
  grownUpLayer: "מבוגרים",
  receiptNumber: "מספר קבלה",
  receiptNumberNotFound: "מספר קבלה לא נמצא",
  event_code: "קוד אירוע",
  personal_id: 'ת"ז',
  payer_name: "שם משלם",
  issuer_name: "שם מנפיק",
  card_info: "פרטי הכרטיס",
  validity: "תוקף",
  brand_type: "סוג מותג",
  card_type: "סוג כרטיס",
  approvement_code: "קוד אישור",
  return_dialog: "דו שיח בקשות החזר",
  time_and_date: "תאריך ושעה",
  details: "פירוט",
  note: "הערה",
  return_sum: "סכום החזר",
  return_percent: "אחוז החזר",
  automatic_fill: "מילוי אוטומטי",
  answers_to_questions: "תשובות לשאלות הרשמה",
  mihlol: "מכלול",
  collection: "אוסף",
  results: "תוצאות",
  were_found: "נמצאו",
  total_subsidies_for_search: "סך הסכום שמסובסד לחיפוש",
  recepts_i_issued: "קבלות בהפקתי",
  overdue_receipts: "קבלות בחריגת זמן הפקדה",
  total_receipts_sum: " סך הסכום להפקדה",
  results_not_found: "לא נמצאו תוצאות התואמות לחיפוש",
  missing_deposit_number: "מס' הפקדה חסרה",
  date: "תאריך",
  name: "שם",
  summary: "סיכום",
  refundAdminCode: "סיסמת מנהל החזרים",
  amount_not_legal: "סכום לא תקני",
  count: "ספירה",
  refund_error_general: "בעיה בשמירת הנתונים",
  wrong_code: "קוד מנהל לא נכון",
  refund_types: "סוגי החזרים",
  cancel_participation: "ביטול השתתפות",
  enter: "הכנס",
  loading_data: "טוען נתונים",
  refindRequestedIn: "בקשת ההחזר הוגשה",
  refundHoursDiffrencesBefore: "שעות מתחילת האירוע. האירוע התחיל ב",
  refundHoursDiffrencesAfter: "שעות לאחר תחילת האירוע. האירוע התחיל ב",
  excel_download_error:
    "לא הצלחנו להוריד את האקסל. אנא נסה מאוחר יותר או פנה למנהל המערכת",
  excel_download_no_cash_results_found: "לא נמצאו תוצאות החזרי מזומן",
  collective_refund_error_more_then_20_payment:
    "אין אפשרות לבצע החזר עבור יותר מ20 הרשמות",
  collective_refund_warning_select_20_payments:
    "בחרת 20 הרשמות, אין אפשרות לבצע החזר עבור יותר מ20 הרשמות",
  additional_details: "פרטים נוספים",
  answer_too_long: "יותר מדי תווים",
};



// WEBPACK FOOTER //
// ./src/tests/fixtures/messages.fixture.ts